import React, { Children } from 'react';
import { Star, ExternalLink, Check } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  platform: 'Zillow',
  rating: 4.9,
  count: 142,
  link: '#'
}, {
  platform: 'Google',
  rating: 4.8,
  count: 89,
  link: '#'
}, {
  platform: 'Yelp',
  rating: 4.7,
  count: 56,
  link: '#'
}, {
  platform: 'Facebook',
  rating: 4.8,
  count: 34,
  link: '#'
}];
const themes = [{
  text: 'Always available, responsive communication',
  count: '20+'
}, {
  text: 'Walks you through every step of the process',
  count: '15+'
}, {
  text: 'Deep local market knowledge of SF neighborhoods',
  count: '12+'
}, {
  text: 'Patient, zero-pressure approach',
  count: '10+'
}, {
  text: 'Team depth — Marcus and his team praised by name',
  count: '10+'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function SellerReviews() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-576">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} variants={containerVariants} data-id="element-577">
        
        <motion.div variants={itemVariants} className="mb-3" data-id="element-578">
          <h2 className="text-2xl font-serif text-brand-dark" data-id="element-579">
            What sellers are saying
          </h2>
        </motion.div>

        <motion.div variants={itemVariants} className="flex flex-wrap items-center gap-3 mb-2" data-id="element-580">
          
          {reviews.map(r => <a key={r.platform} href={r.link} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white border border-brand-light hover:border-brand-forest hover:shadow-sm text-sm transition-all group" data-id="element-581">
            
              <Star size={14} className="fill-amber-400 text-amber-400" data-id="element-582" />
              <span className="font-mono text-sm font-medium text-brand-dark" data-id="element-583">
                {r.rating}
              </span>
              <span className="text-brand-dark" data-id="element-584">{r.platform}</span>
              <span className="text-brand-muted text-xs font-mono" data-id="element-585">
                ({r.count})
              </span>
              <ExternalLink size={12} className="text-brand-muted opacity-0 group-hover:opacity-100 transition-opacity ml-1" data-id="element-586" />
            
            </a>)}
        </motion.div>

        <motion.div variants={itemVariants} className="mb-8" data-id="element-587">
          <p className="text-sm text-brand-muted" data-id="element-588">
            AI-generated themes from verified client reviews
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-589">
          {themes.map((theme, idx) => <motion.div key={idx} variants={itemVariants} className="flex items-start gap-3" data-id="element-590">
            
              <Check className="text-brand-forest shrink-0 mt-0.5" size={18} strokeWidth={3} data-id="element-591" />
            
              <p className="text-sm" data-id="element-592">
                <span className="font-semibold text-brand-dark" data-id="element-593">
                  {theme.text}
                </span>{' '}
                <span className="text-brand-muted text-xs" data-id="element-594">
                  (mentioned {theme.count} times)
                </span>
              </p>
            </motion.div>)}
        </div>

        <motion.div variants={itemVariants} className="pt-8 border-t border-brand-light" data-id="element-595">
          
          <p className="font-serif italic text-brand-muted text-sm leading-relaxed" data-id="element-596">
            "Across 280+ reviews on Yelp, Zillow, Google, and Facebook, clients
            consistently praise Marcus and his team for their deep neighborhood
            expertise, guiding first-time and repeat sellers through every
            detail, and negotiating well above asking price with genuine
            professionalism."
          </p>
        </motion.div>
      </motion.div>
    </section>;
}